import { Flex } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

export const PublicRecordInfoColumn = ({ children }: PropsWithChildren<unknown>) => (
  <Flex flexDirection="column" flexGrow={1} flexShrink={1} minWidth="15rem">
    {children}
  </Flex>
);
